import Head from 'next/head';

import { useGlobalContext } from '@/hooks/use-global-context';

export default function PageHead() {
  const { pageMeta } = useGlobalContext();
  const titlePrefix = pageMeta.title ? `${pageMeta.title} | ` : '';
  const title = titlePrefix + 'Nomad Health';
  const description = pageMeta.description || null;
  const keywords = pageMeta.keywords.join(', ') || null;
  const imageUrl = pageMeta.image?.url || null;
  const noIndex = pageMeta.noIndex;

  return (
    <Head>
      <title>{title}</title>
      <meta property='og:title' content={title} key='title' />
      {description && (
        <meta
          name='description'
          property='og:description'
          content={description}
        />
      )}

      {imageUrl && <meta property='og:image' content={imageUrl} />}
      {keywords && <meta property='keywords' content={keywords} />}
      {noIndex && <meta name='robots' content='noindex' />}
    </Head>
  );
}
